import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import country from 'config/countryConfig';

import './Footer.scss';

const SUPPORT_EMAIL = country.supportEmail;

export function Footer() {
  const { t } = useTranslation();
  return (
    <footer className="footer-main">
      <div className="footer">
        <div className="container-fluid p-0">
          <div className="row">
            <div className="col-md-6">
              <div className="contacts">
                <h3>{country.brandName}</h3>
                <ul>
                  {country.officeAddress && country.officeAddress !== 'TODO_FILL_IN' && (
                    <li>
                      <FontAwesomeIcon
                        icon={['fas', 'globe']}
                      />
                      <span style={{ whiteSpace: 'pre-line' }}>
                        {country.officeAddress}
                      </span>
                    </li>
                  )}
                  {country.contactPhone && country.contactPhone !== 'TODO_FILL_IN' && (
                    <li>
                      <FontAwesomeIcon
                        icon={['fas', 'phone']}
                      />
                      <a href={`tel:${country.contactPhone}`}>{country.contactPhone}</a>
                    </li>
                  )}
                  <li>
                    <FontAwesomeIcon
                      icon={['fas', 'envelope']}
                    />
                    {SUPPORT_EMAIL}
                  </li>
                </ul>
              </div>
            </div>

            <div className="col-md-3">
              <div className="navigations">
                <h3>{t('layout.publicFooter.navigationsHeading')}</h3>
                <ul className="list-unstyled">
                  <li>
                    <Link to="/#">
                      {t('layout.publicFooter.aboutUs')}
                    </Link>
                  </li>
                  <li>
                    <Link to="/faq">
                      {t('layout.publicFooter.faqsPage')}
                    </Link>
                  </li>
                  <li>
                    <Link to="/#">
                      {t('layout.publicFooter.checkout')}
                    </Link>
                  </li>
                  <li>
                    <Link to="/#">
                      {t('layout.publicFooter.contact')}
                    </Link>
                  </li>
                  <li className="">
                    <Link to="/#">
                      {t('layout.publicFooter.blog')}
                    </Link>
                  </li>
                </ul>
              </div>
            </div>

            <div className="col-md-3">
              <div className="help">
                <h3>{t('layout.publicFooter.helpHeading')}</h3>
                <ul className="list-unstyled">
                  <li>
                    <Link to="/#">
                      {t('layout.publicFooter.documentation')}
                    </Link>
                  </li>
                  <li>
                    <Link to="/#">
                      {t('layout.publicFooter.liveChat')}
                    </Link>
                  </li>
                  <li>
                    <Link to="/#">{t('layout.publicFooter.mailUs')}</Link>
                  </li>
                  <li>
                    <Link to="/#">{t('layout.publicFooter.contactHelp')}</Link>
                  </li>
                  <li>
                    <Link to="/#">{t('layout.publicFooter.blogHelp')}</Link>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="copy-rights">
        <p className="mb-0 text-a-d-4">
          © 2022 {country.brandName}.
          {' '}
          {t('layout.publicFooter.versionLabel')}
          {' '}
          {process.env.REACT_APP_VERSION}
          .
        </p>
      </div>
    </footer>
  );
}
